var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }